import React from 'react';

const Zendesk = (props) => (
  <svg
    fill="none"
    stroke="currentColor"
    viewBox="0 0 32 32"
    strokeWidth={2}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M24.068 20.44c-0.001 0-0.002 0-0.003 0-3.823 0-6.923 3.1-6.923 6.923 0 0.001 0 0.003 0 0.004v-0h13.854c0-0 0-0 0-0 0-3.825-3.101-6.926-6.926-6.926-0 0-0 0-0 0h0zM14.858 10.643l-13.854 16.724h13.854zM1.004 4.636c0 3.826 3.101 6.927 6.927 6.927s6.927-3.101 6.927-6.927v0zM17.142 4.633v16.728l13.854-16.726h-13.854z" />
  </svg>
);

export default Zendesk;